import { AppLayout } from "@bcc/components/app-layout";
import { CustomersView } from "@bcc/components/views/customers-view";

export function CustomersPage() {
  const statsData = [
    {
      name: "Total Customers",
      value: "2,451",
      icon: "users",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
    },
    {
      name: "Active Customers",
      value: "1,892",
      icon: "user-check",
      iconBg: "bg-green-100",
      iconColor: "text-green-600",
    },
    {
      name: "VIP Members",
      value: "342",
      icon: "crown",
      iconBg: "bg-purple-100",
      iconColor: "text-purple-600",
    },
    {
      name: "Total Revenue",
      value: "$184,920",
      icon: "dollar-sign",
      iconBg: "bg-amber-100",
      iconColor: "text-amber-600",
    },
  ];

  const customersData = [
    {
      id: 1,
      name: "Alice Johnson",
      email: "alice.johnson@email.com",
      phone: "+1 (555) 123-4567",
      orders: 24,
      totalSpent: "$3,450.00",
      status: "active" as const,
      tier: "VIP" as const,
    },
    {
      id: 2,
      name: "Bob Mitchell",
      email: "bob.mitchell@email.com",
      phone: "+1 (555) 234-5678",
      orders: 18,
      totalSpent: "$2,180.50",
      status: "active" as const,
      tier: "Regular" as const,
    },
    {
      id: 3,
      name: "Carol Davis",
      email: "carol.davis@email.com",
      phone: "+1 (555) 345-6789",
      orders: 42,
      totalSpent: "$6,920.00",
      status: "active" as const,
      tier: "VIP" as const,
    },
    {
      id: 4,
      name: "David Chen",
      email: "david.chen@email.com",
      phone: "+1 (555) 456-7890",
      orders: 5,
      totalSpent: "$450.25",
      status: "inactive" as const,
      tier: "Regular" as const,
    },
    {
      id: 5,
      name: "Emma Wilson",
      email: "emma.wilson@email.com",
      phone: "+1 (555) 567-8901",
      orders: 31,
      totalSpent: "$5,280.75",
      status: "active" as const,
      tier: "VIP" as const,
    },
  ];

  return (
    <AppLayout>
      <CustomersView statsData={statsData} customersData={customersData} />
    </AppLayout>
  );
}
